var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.defaultValue')
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": _vm.optionModel.format,
      "value-format": "HH:mm:ss"
    },
    on: {
      "change": _vm.emitDefaultValueChange
    },
    model: {
      value: (_vm.optionModel.defaultValue),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "defaultValue", $$v)
      },
      expression: "optionModel.defaultValue"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5906ab6f","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-time/time-defaultValue-editor.vue
// module id = null
// module chunks = 